<template>
  <static-content-wrapper
    :designer="designer"
    :field="field"
    :design-state="designState"
    :parent-widget="parentWidget"
    :parent-list="parentList"
    :index-of-parent-list="indexOfParentList"
    :sub-form-row-index="subFormRowIndex"
    :sub-form-col-index="subFormColIndex"
    :sub-form-row-id="subFormRowId"
  >
    <van-notice-bar :left-icon="leftIcon" :text="field.options.title" :mode="closable" :color="effect.color" :background="effect.background" @close="handleCloseCustomEvent" />
  </static-content-wrapper>
</template>

<script>
import { reactive, toRefs, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from '@/utils/i18n';
import { useEmitter } from '@/utils/emitter';
import { useField } from '@/components/form-designer/form-widget/field-widget/fieldMixin';
import StaticContentWrapper from '@/components/form-designer/form-widget/field-widget/static-content-wrapper';

export default {
  componentName: 'FieldWidget', //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  components: {
    StaticContentWrapper,
  },
  name: 'alert-widget',
  props: {
    designState: {
      default: false,
      type: Boolean,
    },
    designer: Object,
    field: Object,
    indexOfParentList: Number,
    parentList: Array,

    parentWidget: Object,

    subFormColIndex: {
      default: -1,
      /* 子表单组件列索引，从0开始计数 */
      type: Number,
    },
    subFormRowId: {
      default: '',
      /* 子表单组件行Id，唯一id且不可变 */
      type: String,
    },
    subFormRowIndex: {
      default: -1,
      /* 子表单组件行索引，从0开始计数 */
      type: Number,
    },
  },
  setup(props) {
    const data = reactive({
      effect: {
        background: '#DCDEE0',
        color: '#646566',
      },
    });

    const { i18nt } = useI18n();
    const emitterMixin = useEmitter();
    const fieldMixin = useField(data);

    const closable = computed(() => {
      if (props.field.options.closable) {
        return 'closeable';
      } else {
        return '';
      }
    });

    const leftIcon = computed(() => {
      if (props.field.options.showIcon) {
        return 'info';
      } else {
        return undefined;
      }
    });

    watch(
      () => props.field.options.type,
      () => {
        refreshEffect();
      }
    );

    const refreshEffect = () => {
      switch (props.field.options.type) {
        case 'success':
          data.effect.color = '#FFFFFF';
          data.effect.background = '#95D475';
          break;
        case 'warning':
          data.effect.color = '#FFFFFF';
          data.effect.background = '#EEBE77';
          break;
        case 'info':
          data.effect.color = '#646566';
          data.effect.background = '#DCDEE0';
          break;
        case 'error':
          data.effect.color = '#FFFFFF';
          data.effect.background = '#F89898';
          break;
        default:
          data.effect.color = '#646566';
          data.effect.background = '#DCDEE0';
      }
    };

    const handleCloseCustomEvent = () => {
      if (!!props.field.options.onClose) {
        let changeFn = new Function(props.field.options.onClose);
        changeFn.call(this);
      }
    };

    onBeforeUnmount(() => {
      fieldMixin.unregisterFromRefList();
    });

    fieldMixin.registerToRefList();
    fieldMixin.initEventHandler();
    refreshEffect();

    return {
      i18nt,
      ...toRefs(props),
      ...toRefs(data),
      ...fieldMixin,

      closable,
      handleCloseCustomEvent,

      leftIcon,
    };
  },
};
</script>

<style lang="scss" scoped></style>
